import { useTranslation } from 'react-i18next';

/** Below this many characters a search matches too much to be worth showing. */
export const SEARCH_MIN_LENGTH = 3;

/**
 * Tells the caller whether a query is long enough to search with.
 *
 * Kept beside the field so that the rule and the hint that explains it cannot
 * drift apart: a list that stays empty at two characters and a field that never
 * says why is the same bug twice.
 */
export function isSearchReady(query, minLength = SEARCH_MIN_LENGTH) {
  return query.trim().length >= minLength;
}

function SearchField({
  value,
  onChange,
  placeholder,
  ariaLabel,
  minLength = SEARCH_MIN_LENGTH,
}) {
  const { t } = useTranslation();

  const typed = value.trim().length;
  const isTooShort = typed > 0 && typed < minLength;

  return (
    <div className="admin-search">
      <div className="admin-user-search">
        <i className="fa-solid fa-magnifying-glass" />

        <input
          type="text"
          value={value}
          placeholder={placeholder}
          aria-label={ariaLabel}
          onChange={(event) => onChange(event.target.value)}
        />
      </div>

      {isTooShort && (
        <p className="admin-search-hint">
          {t('adminPanel.searchTooShort', { count: minLength })}
        </p>
      )}
    </div>
  );
}

export default SearchField;
